const BASE_URL = `${process.env.VUE_APP_API_URL}`

// Auth //
export const API_AUTH = {
  LOGIN: `${BASE_URL}/auth/v1/auth?lang=id`,
  FORGOT_PASSWORD: `${BASE_URL}/auth/v1/forgot/password?lang=id`,
  CHANGE_PASSWORD: `${BASE_URL}/auth/v1/change-password?lang=id`,
  GET_USER_PROFILE: `${BASE_URL}/v1/user_by_token?lang=id`,
  EMAIL_ACTIVATION:  `${BASE_URL}/auth/v1/activation`,
  CHANGE_PASSWORD_PROFILE: `${BASE_URL}/v1/user_change_password`
}

// Core //
export const API_CORE = {
  COMPANY_LOAD: `${BASE_URL}/v1/core/company`,
  SYNC_COMPANY: `${BASE_URL}/v1/core/setup-param`,
  SYNC_INVOICE: `${BASE_URL}/v1/core/insert-mutation`,
  SYNC_JOURNAL: `${BASE_URL}/v1/core/insert-journal`,
  SYNC_RETRY: id => `${BASE_URL}/v1/sync-core/${id}`,
  SYNC_LOG_RETRY: id => `${BASE_URL}/v1/sync-log/${id}`,
  SYNC_LOG_DETAIL: id => `${BASE_URL}/v1/sync-log/${id}`,
  SYNC_DETAIL: id => `${BASE_URL}/v1/sync-core/${id}`,
  GENERATE_PARTICIPANT: `${BASE_URL}/v1/core/generate-participant`,
  SYNC_SUBDIVISION: id => `${BASE_URL}/v1/core/sync-subdivision/${id}`,
  LOG_SYNC_LIST: `${BASE_URL}/v1/sync-core`,
  SYNC_LOG_LIST: `${BASE_URL}/v1/sync-log`,
  SYNC_LOG_CORE_LIST: `${BASE_URL}/v1/sync-log/core`,
  SYNC_LOG_CORE_DETAIL: id => `${BASE_URL}/v1/sync-log/core/${id}`,
  INVESTMENT_ALLOCATION_LIST: `${BASE_URL}/v1/core/master-investment`,
  VALID_USER_LIST: `${BASE_URL}/v1/core/valid-user-load`
}

// Company //
export const API_COMPANY = {
  LIST: `${BASE_URL}/v1/company`,
  CREATE_COMPANY: `${BASE_URL}/v1/company?lang=id`,
  BY_ID: id => `${BASE_URL}/v1/company/${id}?lang=id`,
  BY_ID_LPD: id => `${BASE_URL}/v1/company/balance/report/${id}`,
  DOWNLOAD_LPD: id => `${BASE_URL}/v1/company/balance/generate/${id}`,
  REGENERATE_E_CERTIFICATE: id => `${BASE_URL}/v1/company/${id}/regenerate-e-certificate`,
  COMPANY_EXISTING: `${BASE_URL}/v1/company-existing`,
  LIST_ADENDUM: `${BASE_URL}/v1/addendume`,
  LIST_RIPLAY: `${BASE_URL}/v1/riplay`,
  RIPLAY_BY_ID: id => `${BASE_URL}/v1/riplay/${id}`,
  EXPORT_EMPLOYEE: id => `${BASE_URL}/v1/employee/working-position/export/${id}?lang=id`,
  CREATE_BULK_EMPLOYEE_POSITION: id => `${BASE_URL}/v1/employee/working-position/upload/${id}`
}

// Employee //
export const API_EMPLOYEE = {
  LIST: `${BASE_URL}/v1/employee`,
  CREATE_EMPLOYEE: `${BASE_URL}/v1/employee?lang=id`,
  BY_ID: id => `${BASE_URL}/v1/employee/${id}?lang=id`,
  ADD_PROGRAM_EMPLOYEE: `${BASE_URL}/v1/employee_benefit_recipient`,
  BY_TOKEN: `${BASE_URL}/v1/employee_by_token?lang=id`,
  UPDATE_EMPLOYEE_ACCESS: id => `${BASE_URL}/v1/employee_access/${id}`,
  UPDATE_EMPLOYEE_ACCESS_BULK: `${BASE_URL}/v1/employee/access`,
  EMPLOYEE_BALANCE_REPORT: id => `${BASE_URL}/v1/employee/balance/report/${id}`,
  EMPLOYEE_PROGRAM_LIST: `${BASE_URL}/v1/employee_program`,
  EMPLOYEE_ONBOARDING_PML: `${BASE_URL}/v1/employee/pml?lang=id`,
  EMPLOYEE_BACK_PAY: `${BASE_URL}/v1/deposit?lang=id`,
  EMPLOYEE_RAPEL: id => `${BASE_URL}/v1/employee/${id}/rapel?lang=id`,
  EMPLOYEE_RAPEL_SALARY_OPTIONS: id => `${BASE_URL}/v1/employee/${id}/rapel/salary-options?lang=id`,
  REGENERATE_E_CERTIFICATE: id => `${BASE_URL}/v1/employee/${id}/regenerate-e-certificate`
}

// Employee Existing Sync //
export const API_EMPLOYEE_EXISTING_SYNC = {
  LIST: `${BASE_URL}/v1/employee-existing-sync`,
  BY_ID: id => `${BASE_URL}/v1/employee-existing-sync/${id}`,
  UPLOAD_REVISION: `${BASE_URL}/v1/employee-existing-sync/upload-revision`,
  SAVE: companyCode => `${BASE_URL}/v1/employee-existing?company_code=${companyCode}`
}

// Employee Mutation //
export const API_EMPLOYEE_MUTATION = {
  LIST: `${BASE_URL}/v1/employee-mutation`,
  CREATE: `${BASE_URL}/v1/employee-mutation`,
  BY_ID: id => `${BASE_URL}/v1/employee-mutation/${id}`,
  HISTORY: employeeId => `${BASE_URL}/v1/employee-mutation/history/${employeeId}`,
  UPLOAD_ADDENDUM: `${BASE_URL}/v1/employee-mutation/upload-addendum`
}

// Program Setting //
export const API_PROGRAM_SETTING = {
  LIST: `${BASE_URL}/v1/program_setting`
}

// Bulk //
export const API_BULK = {
  LIST: `${BASE_URL}/v1/bulk?lang=id`,
  BY_ID: id => `${BASE_URL}/v1/bulk/${id}`,
  BY_CODE: `${BASE_URL}/v1/bulk_detail`,
  TEMPLATE_IURAN: id => `${BASE_URL}/v1/employee_program/export/${id}`,
  CREATE_BULK_EMPLOYEE: `${BASE_URL}/v1/employee/upload?lang=id`,
  CREATE_BULK_IURAN: `${BASE_URL}/v1/employee_program/upload?lang=id`,
  CREATE_BULK_COMPANY_SUBDIVISION: `${BASE_URL}/v1/company_subdivision/upload?lang=id`
}

// Company Subdivision //
export const API_COMPANY_SUBDIVISION = {
  LIST: `${BASE_URL}/v1/company_subdivision`,
  CREATE_COMPANY_SUBDIVISION: `${BASE_URL}/v1/company_subdivision?lang=id`,
  BY_ID: id => `${BASE_URL}/v1/company_subdivision/${id}`
}

// Updated Data //
export const API_UPDATED = {
  LIST: `${BASE_URL}/v1/change`,
  BY_ID: id => `${BASE_URL}/v1/change/${id}?lang=id`
}

// Claim //
export const API_CLAIM = {
  LIST: `${BASE_URL}/v1/claim`,
  LIST_DASHBOARD: `${BASE_URL}/v1/claim_dashboard`,
  CREATE_CLAIM: `${BASE_URL}/v1/claim?lang=id`,
  BY_ID: id => `${BASE_URL}/v1/claim/${id}?lang=id`,
  HISTORY: id => `${BASE_URL}/v1/claim/${id}/history`,
  EMPLOYEE_PROGRAM_BALANCE: (id, source) => `${BASE_URL}/v1/employee_program/balance/${id}?lang=id${source ? `&source=${source}` : ''}`,
  RESOLVE_MAPPING: `${BASE_URL}/v1/claim/mapping/resolve`,
  TAX_REPORT_EVIDENCE: id => `${BASE_URL}/v1/claim/${id}/tax-report-evidence?lang=id`,
  SUPPORTING_DOCUMENT: id => `${BASE_URL}/v1/claim/${id}/supporting-document?lang=id`,
  DEEP_LINK: token => `${BASE_URL}/v1/claim/deep-link/${token}`,
  DOCUMENT_STRUCTURE_CHECK: `${BASE_URL}/v1/claim/document/structure-check?lang=id`
}

// Log Activity //
export const API_LOG_ACTIVITY = {
  LIST: `${BASE_URL}/v1/log/cms`,
  LIST_ROLE: `${BASE_URL}/v1/log/cms_role_name`,
  LIST_MODULE: `${BASE_URL}/v1/log/cms_module_name`
}

// Invoice Payment //
export const API_INVOICE = {
  LIST: `${BASE_URL}/v1/invoice`,
  CREATE_INVOICE: `${BASE_URL}/v1/invoice?lang=id`,
  CREATE_INVOICE_ADHOC: `${BASE_URL}/v1/invoice/adhoc?lang=id`,
  BY_ID: id => `${BASE_URL}/v1/invoice/${id}?lang=id`
}

// Journal Contribution //
export const API_JOURNAL_CONTRIBUTION = {
  LIST: `${BASE_URL}/v1/journal`,
  LIST_BY_COMPANY: `${BASE_URL}/v1/journal/company`,
  BY_ID: id => `${BASE_URL}/v1/journal/${id}`,
  DOWNLOAD: id => `${BASE_URL}/v1/journal/${id}/download`,
  DOWNLOAD_COMPANY: (companyId, invoiceNumber) => `${BASE_URL}/v1/core/journal/company/download?company_id=${companyId}&invoice_number=${encodeURIComponent(invoiceNumber)}`,
  LOG_DOWNLOAD_FAILURE: `${BASE_URL}/v1/journal/log-download-failure`
}

// Payment Company //
export const API_PAYMENT_COMPANY = {
  LIST: `${BASE_URL}/v1/invoice`,
  BY_ID: id => `${BASE_URL}/v1/invoice/${id}`
}

// Analytic //
export const API_ANALYTIC = {
  EMPLOYEE_COUNT_BY_STATUS: `${BASE_URL}/v1/analytic/employee-count-by-status`,
  EMPLOYEE_PERCENTAGE_BY_STATUS: `${BASE_URL}/v1/analytic/employee-percentage-by-status`,
  EMPLOYEE_TOTAL_DATA_CHANGE: `${BASE_URL}/v1/analytic/employee-data-change`,
  TOTAL_CLAIM: `${BASE_URL}/v1/analytic/claim`,
  TOTAL_EMPLOYEE: `${BASE_URL}/v1/analytic/employee`,
  COMPANY_INVESTMENT: `${BASE_URL}/v1/analytic/company-investment-calculation`,
  SUMMARY: `${BASE_URL}/v1/analytic/summary`,
  RECAP_PARTICIPANT: `${BASE_URL}/v1/analytic/recap-participant`,
  RECAP_COMPANY: `${BASE_URL}/v1/analytic/recap-company`,
  RECAP_COMPANY_EXPORT: `${BASE_URL}/v1/analytic/recap-company/export`
}

// LPD - Laporan Posisi Dana //
export const API_LPD = {
  SUMMARY: `${BASE_URL}/v1/lpd/summary`,
  PROGRAM_POSITION: `${BASE_URL}/v1/lpd/program-position`,
  TOP_COMPANIES: `${BASE_URL}/v1/lpd/top-companies`,
  DETAIL: `${BASE_URL}/v1/lpd/detail`,
  DETAIL_EXPORT: `${BASE_URL}/v1/lpd/detail/export`,
  INVESTMENT_DETAIL: `${BASE_URL}/v1/lpd/investment-detail`,
  INVESTMENT_DETAIL_EXPORT: `${BASE_URL}/v1/lpd/investment-detail/export`,
  LATEST_UPC_DATE: `${BASE_URL}/v1/lpd/latest-upc-date`,
  COMPANIES: `${BASE_URL}/v1/lpd/companies`,
  COMPANY_BY_ID: id => `${BASE_URL}/v1/lpd/companies/${id}`,
  COMPANY_REPORT: (companyId, programSettingId) => `${BASE_URL}/v1/lpd/companies/${companyId}/programs/${programSettingId}/report`,
  COMPANY_REPORT_EXPORT: (companyId, programSettingId) => `${BASE_URL}/v1/lpd/companies/${companyId}/programs/${programSettingId}/report/export`
}
// Bank //
export const API_BANK = {
  LIST: `${BASE_URL}/v1/bank`,
  CREATE_COMPANY: `${BASE_URL}/v1/bank`,
  BY_ID: id => `${BASE_URL}/v1/bank/${id}`,
  LIST_BANK_INSTALLMENT: `${BASE_URL}/v1/bank_installment`
}

// Role //
export const API_ROLE = {
  LIST: `${BASE_URL}/v1/role`,
  CREATE_ROLE: `${BASE_URL}/v1/role`,
  BY_ID: id => `${BASE_URL}/v1/role/${id}`
}

// User //
export const API_USER = {
  LIST: `${BASE_URL}/v1/user`,
  CREATE_USER: `${BASE_URL}/v1/user?lang=id`,
  BY_ID: id => `${BASE_URL}/v1/user/${id}`
}

// Report //
export const API_REPORT = {
  LIST: `${BASE_URL}/v1/report/file`,
  CREATE_REPORT: `${BASE_URL}/v1/report/file`,
  BY_ID: id => `${BASE_URL}/v1/report/file/${id}`
}

// Forms //
export const API_FORMS = {
  LIST: `${BASE_URL}/v1/form`,
  CREATE_FORMS: `${BASE_URL}/v1/form`,
  BY_ID: id => `${BASE_URL}/v1/form/${id}`
}

// Type Investment //
export const API_TYPE_INVESTMENT = {
  LIST: `${BASE_URL}/v1/type-investment`
}

// Source Scope //
export const API_SOURCE_SCOPE = {
  LIST_SOURCE_SCOPE: `${BASE_URL}/v1/source_scope`,
  SOURCE_SCOPE_DETAIL:  `${BASE_URL}/v1/source_scope_detail`,
  SOURCE_SCOPE_DETAIL_GROUPED: `${BASE_URL}/v1/source_scope_detail/grouped`
}

// Master Data //
export const API_MASTER_DATA = {
  LIST_STATUS: `${BASE_URL}/v1/status`,
  LIST_PROVINCE: `${BASE_URL}/v1/province`,
  LIST_CITY: `${BASE_URL}/v1/city`,
  LIST_DISTRICT: `${BASE_URL}/v1/district`,
  LIST_VILLAGE: `${BASE_URL}/v1/village`
}

// Notification //
export const API_NOTIFICATION = {
  LIST: `${BASE_URL}/v1/notification`
}

export const API_FCM = {
  ADD_FCM: `${BASE_URL}/v1/token?lang=id`
}

// Menu //
export const API_MENU = {
  GET_ALL_MENU: `${BASE_URL}/v1/menu`,
  LIST_BY_TOKEN: `${BASE_URL}/v1/menu_by_token`
}

// Notification Payment Email //
export const API_NOTIFICATION_PAYMENT = {
  LIST: `${BASE_URL}/v1/notification_payment`,
  CREATE_NOTIFICATION: `${BASE_URL}/v1/notification_payment`,
  BY_ID: id => `${BASE_URL}/v1/notification_payment/${id}`
}

// Email Broadcast //
export const API_EMAIL_BROADCAST = {
  LIST_BROADCAST: `${BASE_URL}/v1/broadcast?lang=id`,
  LIST_LOG_EMAIL: `${BASE_URL}/v1/notification/emails`,
  CREATE_EMAIL_BROADCAST: `${BASE_URL}/v1/broadcast`,
  BY_ID: id => `${BASE_URL}/v1/broadcast/${id}`,
  RESEND_EMAIL: id => `${BASE_URL}/v1/notification/emails/${id}`
}

// Configuration Retirement //
export const API_CONFIGURATION = {
  LIST: `${BASE_URL}/v1/configuration`,
  PML_PERCENTAGE_MULTIPLIER: `${BASE_URL}/v1/configuration/1c0eb048-09eb-4964-a512-7f9c3950fa34`,
  BY_ID: id => `${BASE_URL}/v1/configuration/${id}?lang=id`
}

export const API_TERMS_CONDITION = {
  LIST: `${BASE_URL}/v1/terms-condition`,
  BY_ID: id => `${BASE_URL}/v1/terms-condition/${id}?lang=id`,
  UPDATE_TNC: `${BASE_URL}/v1/terms-condition/accept?lang=id`
}

export const API_CORE_MAPPING = {
  LIST: `${BASE_URL}/v1/core-mapping`
}
